module.exports = __webpack_public_path__ + "img/grand prize.4e986606.svg";